export const schema = {
  scenario: [
    {
      name: 'loadRecommendationTab',
      value: 'LoadRecommendationTab',
      setting: {},
      activity: [
        {
          name: 'loadRecommendationTab',
          value: 'LoadRecommendationTab',
        },
        // Below activities are for performance logs.
        {
          name: 'getSummary',
          value: 'getsummary',
        },
        {
          name: 'getCoupons',
          value: 'getCoupons',
        },
        {
          name: 'getHistory',
          value: 'getHistory',
        },
        {
          name: 'getCount',
          value: 'getCount',
        },
        {
          name: 'track',
          value: 'track',
        },
        {
          name: 'viewCategory',
          value: 'ViewCategory',
        },
        {
          name: 'getAutoApplyOptInStatus',
          value: 'getAutoApplyOptInStatus',
        },
        {
          name: 'setAutoApplyOptInStatus',
          value: 'setAutoApplyOptInStatus',
        },
        {
          name: 'getBulkAarUploadBlobUrl',
          value: 'getBulkAarUploadBlobUrl',
        },
        {
          name: 'submitBulkAarOptInStatusTask',
          value: 'submitBulkAarOptInStatusTask',
        },
        {
          name: 'pollBulkAarOptInStatusTask',
          value: 'pollBulkAarOptInStatusTask',
        },
      ],
    },
  ],
};
